import { memo, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import toast from "react-hot-toast";
import axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { taxSchema } from "../../app/schema";
import { useDispatch } from "react-redux";
import { showModal, hideConfirmModal } from "../../redux/counterSlice";
import { FormInputText } from "../form-components/FormInputText";

function AddTax({
  open,
  handleClose,
  selectedRow: selectedTaxRow,
  loadInitialData,
}) {
  const dispatch = useDispatch();
  const isEditMode = selectedTaxRow && selectedTaxRow.tax_id;

  const methods = useForm({
    resolver: yupResolver(taxSchema),
    defaultValues: {
      tax_percentage: "",
    },
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = methods;

  useEffect(() => {
    if (selectedTaxRow) {
      reset({
        tax_percentage: selectedTaxRow?.tax_percentage || "",
      });
    } else {
      reset({
        tax_percentage: "",
      });
    }
  }, [selectedTaxRow, reset]);

  const onSubmit = async (data) => {
    const payload = {
      tax_percentage: parseFloat(data.tax_percentage),
      ...(isEditMode && { tax_id: selectedTaxRow.tax_id }),
    };

    try {
      const endpoint = isEditMode ? "/updateTax" : "/createTax";
      const response = await axios.post(endpoint, payload);

      if (!response?.data?.error) {
        toast.success(response?.data?.message || "Saved successfully");
        loadInitialData();
        reset();
        handleClose();
      } else {
        let errDesc = response?.data?.message || "Something went wrong";
        if (response?.data?.data) {
          errDesc = Object.values(response.data.data).join("\n");
        }
        dispatch(showModal({ msg: errDesc, error: true }));
      }
    } catch (error) {
      dispatch(
        showModal({ msg: error?.message || "Server error", error: true })
      );
    } finally {
      dispatch(hideConfirmModal({ msg: "" }));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle className="text-primary">
        {isEditMode ? "Edit Tax" : "Add Tax"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormInputText
              name="tax_percentage"
              control={control}
              label="Tax Percentage"
              errors={errors}
              mandatory="true"
              defaultValue={selectedTaxRow?.tax_percentage || ""}
              type="number"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="error">
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          startIcon={<SaveIcon />}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(AddTax);
